import { AxiosResponse } from 'axios';
import { api } from './axios';

const devicesEndpoints = {
  devices: '/places-devices',
};

export async function getCsvDataDevices({
  _end,
  _order,
  _sort,
  _start,
}: {
  _end: number;
  _order: string;
  _sort: string;
  _start: number;
}) {
  try {
    const queryStrings = {
      _end,
      _order,
      _sort,
      _start,
    };

    const response: void | AxiosResponse<any> = await api.get(devicesEndpoints.devices, {
      params: queryStrings,
    });

    const devices = response?.data?.devices || [];

    if (!Array.isArray(devices)) {
      return [];
    }

    const csvData = devices.map((device) => ({
      Nome: device.name || '',
      Função: device.function === 'DUAL_CLIENT' ? 'Captura' : 'Caixa/PDV',
      'UUID do Dispositivo': device.deviceUUID || '',
      IMEI: device.imei || '',
      'Data de criação': device.createdAt ? new Date(device.createdAt).toLocaleDateString('pt-BR') : '',
      Estabelecimento: device.place?.name || '',
      Status: device.online ? 'Online' : 'Offline',
    }));

    return csvData;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function addDevice({ deviceUUID, name }: { deviceUUID: string; name: string }) {
  try {
    const payload: object = {
      deviceUUID,
      name,
    };

    const response = await api.post(devicesEndpoints.devices, payload);

    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function updateDeviceById({
  name,
  deviceUUID,
  original,
}: {
  name: string;
  deviceUUID: string;
  original: any;
}) {
  try {
    const payload: object = { ...original, name, deviceUUID };

    const response: void | AxiosResponse<any> = await api.put(`${devicesEndpoints.devices}/${original.id}`, payload);
    return response?.data;
  } catch (error) {
    throw new Error(error.message);
  }
}

export async function deleteDeviceById(id: string) {
  try {
    const response: void | AxiosResponse<any> = await api.delete(`${devicesEndpoints.devices}/${id}`);
    return response?.data;
  } catch (error) {
    throw new Error(error.message);
  }
}
